import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import {
  ICompanyOrganization,
  ICompanyOrganizationCreateDTO,
  ICompanyOrganizationUpdateDTO,
} from '@/shared/model/company-organization.model';

const baseApiUrl = 'api/company-organizations';

export default class CompanyOrganizationService {
  public find(id: number): Promise<ICompanyOrganization> {
    return new Promise<ICompanyOrganization>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: ICompanyOrganizationCreateDTO): Promise<ICompanyOrganization> {
    return new Promise<ICompanyOrganization>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(id: number, entity: ICompanyOrganizationUpdateDTO): Promise<ICompanyOrganization> {
    return new Promise<ICompanyOrganization>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public uploadLogoFile(file: File, companyOrganizationId: number): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const formData = new FormData();
      formData.append('files', file);
      formData.append('companyOrganizationId', companyOrganizationId.toString());

      axios
        .post('api/company-organizations/upload-logo', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then(res => {
          // Response je direktno filename string
          resolve(res.data);
        })
        .catch(err => reject(err));
    });
  }

  public deleteLogoFile(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`api/company-organizations/delete-logo/${id}`)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public retrieveLogoImage(filename: string): string {
    return `api/retrieve/image/${encodeURIComponent(filename)}`;
  }
}
